import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico_Minimize",
  "use": "ico_Minimize-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ico_Minimize\">\n    <path data-name=\"Rectangle 2\" d=\"M6 12h12v1H6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol